import React, {useState, useRef, useEffect, Fragment} from 'react';
import VisDiv from '../frontend_components/VisDiv'
import { richEditorDoc } from '../gestioneDatabase/Docs'
import RichTextEditor from '../RichTextEditor'
import SaveButton from '../frontend_components/SaveButton'
import { useStateContext } from '../../context/StateContext';
import { ImportExcelButton } from '../../lib/excel';
import { errorAlert, unique } from '../../lib/utils';
import TextField from '../TextField';
import { keyId, sortByUpdatedAtDate } from '../../lib/utils'
import { v4 as uuidv4 } from 'uuid';
import {FiEdit, FiSave, FiCopy } from 'react-icons/fi'
import { useCreateReplace } from '../../hooks/mutations';
import PromiseQueue from 'p-queue'
import ManageSchema from '../../components/management/ManageSchema';
import SchemaImport from '../../sanity_ecommerce/schemas/rich-module/richTextLabelValue'
import { successAlert } from '../../lib/utils';
import Divider from '../frontend_components/Divider';
import { useQueryClient } from '@tanstack/react-query';
import FieldDropdown from '../FieldDropdown';
import { addValueForDropdown, removeEmptyProperties, sortByLabel, } from '../../lib/utils'


const Laws = ({data = {}}) => {

    const {
        excelData,
        setExcelData,
    } = useStateContext();
    const queryClient = useQueryClient()
    const {customerProducts, laws} = data
    const [searchNcValue, setSearchNcValue] = useState("");
    const searchNcRef = useRef();

    const onSearchClick = (e) => {
        e.stopPropagation()
      };
      const onSearchNc = (e) => {
        setSearchNcValue(e.target.value);
      };
    


    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['laws'] })
            const previousData = queryClient.getQueryData(['laws'])
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['laws'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData }
        },
        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message);
            errorAlert("Errore: il documento non é stato aggiornato")}
        })
    
    const updateDocs = customerProducts?.map?.((item)=>({
        ...item,
        law: {label: "", value:"", richText: richEditorDoc(item?.law)},
        details: richEditorDoc(item?.details)
    }))

    const uniqueLaws = () => {

        const existingLaws = customerProducts?.map?.((item)=>({law:item?.law}))
        const importedLaws = excelData
        const allLaws = [...existingLaws, ...importedLaws].filter?.((x)=>x?.law)
        const uniqueArray = unique("law", allLaws)
        const richDocs = uniqueArray?.map?.((item)=>({
            value:"",
            label: "",
            _id: uuidv4(),
            _key: keyId(),
            _type:"richTextLabelValue",
            fieldType: "italy-law",
            richText: richEditorDoc(item?.law)
        }))
        return richDocs
    }

    const updateLawInProducts = () => {

    }



    //const [laws, setLaws] = useState(uniqueLaws())
    
    const [allDocs, setAllDocs] = useState(updateDocs)
    const [selectedDoc, setSelectedDoc]= useState()

    const testFunction = () => {
        console.log(SchemaImport)
    }

    const dataSchema = {
        schema: SchemaImport,
        documentName:"richTextLabelValue",
        richTextLabelValue: laws,
        //unique:[{name:"label", array: clients?.map?.(x=>x?.label)}],
        //required:["customer", "label"], 
        //suffix:[{name:"tenderDiscount", suffix:"%"}],
        autoFields:[{schema:"fieldType", value: "italy-law" }],
        hide:["fieldType", "value", "registerTemplates"], 
        //collection: laws
    }

    const save = (data) => {
        //console?.log("DOC TO SAVE", data)
        const queryDoc = {
            doc: data,
        }
        console.log("SAVE DOC", queryDoc)
        updateDocument(queryDoc)
      
    }
/*     const archive = (data) => {
        const queryDoc = {
            doc: data,
        }
        console.log()
        updateClient(queryDoc); 
    } */

    const selectedDocFn = (data) => {
        //console.log("SELECTED DOC",data)
        if(data){
         setSelectedDoc(data)
        }
       
    }

    const importLaws = () => {
        const descriptions = customerProducts?.map?.((item)=>{
            const findLaw = !Array.isArray(laws) ? undefined : laws?.find?.((x)=>item?.law == x?.richText?.blocks[0]?.text)
            if(!item?.details) {
                return({
                    ...item
                })
            
            }
            return({
            ...item,
            details: richEditorDoc(item?.details)
        })
    })
     
        const productsWithUpdatedLaws = customerProducts?.map?.((item)=>{
            const findLaw = !Array.isArray(laws) ? undefined : laws?.find?.((x)=>item?.law == x?.richText?.blocks[0]?.text)
            if(!findLaw) {
             
                return({
                    ...item
                })
            
            }
            return({
            ...item,
            law:{_ref: findLaw?._id, _key: keyId(), _type:"reference"}
        })
    })
    async function update (req, res) {

        const queue = new PromiseQueue({
          concurrency: 8,
          intervalCap: 15,
          interval: 900,
        })
      
        const requests = descriptions.forEach((item) => {
         queue.add(() => {
            const queryDoc = {
                doc: item,
            }
            return updateDocument(queryDoc);     
          })
        })
      };
        console.log("LAWS AND DESCRIPTIONS", descriptions[0])
        //updateDocument({doc: descriptions[0]})
        update()

    }


    const importedData = (excelData) => {
        //console.log("IMPORT EXCEL", data)
        const workedData = !Array.isArray(excelData) ? [] : excelData?.filter?.(x=>x?.norma)?.map?.((item)=>({
            law: item?.norma,
        }))
        setExcelData(workedData)
    
/*         replacePriceList(queryDoc,{
            onSuccess:()=>{
                console.log("Document Updated Successfully");
                const newCustomerDoc = {
                    ...customer,
                    priceLists: [...customer?.priceLists?.filter?.((x)=>x?._key !== doc?._key), doc]
                }
                setCustomer(newCustomerDoc)
        }}) */  
        }
        const lawsFilter = (x) => {
            //const text = x?.richText?.blocks?.map?.((x)=>x?.text)?.toString()
            //console.log("DOC IN FILTER", x)
            //return  text?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0
            const search =  x?.label?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0
            return search 
        }
        
  return (
    <div className="split-view">
        <div style = {{display:"flex", flexDirection:"column"}} className='new-device-container half-left' >
            <div style={{marginBottom:"20px"}}>
                <h2>
                    LEGGI
                </h2>
                <button onClick={testFunction}>test</button>
            </div>
            <ImportExcelButton returnedData = {importedData}/>
            <VisDiv>
            <ManageSchema
                    data = {dataSchema}
                    saveFn={save}
                    selectedDoc={selectedDocFn}
                    //archiveFn={archive}
                />             
            </VisDiv>
            <Divider/>
            <div style={{marginBottom:"15px", marginTop:"15px", display:"flex", justifyContent:"center", flexDirection:"column"}}>
                <p>CERCA NELLE LEGGI</p>
                <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                    <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearchNc} value={searchNcValue} ref={searchNcRef} />
                </div>  
            </div>
           
            {laws?.sort(sortByUpdatedAtDate)?.filter?.(lawsFilter)?.map?.((item, index)=> 
            <div key={item?._id} >
                <LawPin laws={laws} item={item} customerProducts={customerProducts}/>
            </div>
            )
            }
            
        </div>

    </div>
  )
}

export default Laws

export const LawPin = ({laws, key, item, index, customerProducts}) => 
    {
      
  
        const [value, setValue] = useState(item)
        const queryClient = useQueryClient()
       
        const lawProducts = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.((x)=>x?.law?._ref == item?._id)
        const lawProductsLabels = lawProducts?.map?.((item, index)=>{
            return (
                <LawProductsLabels key={item?._id} index={index} product={item} laws={laws}/>
            )
        })

        const {mutate: updateDocument} = useCreateReplace({
            onMutate: async (newDoc) => {

                await queryClient.cancelQueries({ queryKey: ['laws'] })
                const previousData = queryClient.getQueryData(['laws'])
           
                //const doc = newDoc?.doc
                
                queryClient.setQueryData(['laws'], (old) =>{ 
                    const doc = newDoc?.doc
                    const oldData = old?.length > 0 ? old : []
                    const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                    return newData
                })
                return {previousData }
            },
            onError: (err, newDoc, context) => {
                console.error('Oh no, the update failed: ', err?.message)
                errorAlert("Errore: il documento non é stato aggiornato")
            
            }
            })

        const editorDocLaw = (data) => {
            //console.log("EDITOR DOC", data)
            const newValue = {...value, richText: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
            setValue(newValue)
            //setLaws([...filteredArray, newValue])
            

        }
        const editorDocDetails = (data) => {
            //console.log("EDITOR DOC", data)

        }
        const addLabel = (e) => {
            
            const updatedRichText = value?.richText?.blocks
            const newValue = {
                ...value, 
                richText: {
                    ...value?.richText, 
                    blocks: updatedRichText?.map?.((x)=>({...x, _key: x?.key}))
                    }, 
                value: e.target.value, 
                label: e.target.value}
            setValue(newValue)
            
        }
        
        const updateLaw = () => {
            //setLaws([...filteredArray, value])
            
            const queryDoc = {
                doc: value,
            }
            console.log("SAVE LAW:", queryDoc)
            updateDocument(queryDoc)
        }
        const pinTestFunction = () => {
            console.log("pin test", item)
            navigator.clipboard.writeText(item?._id)
        }
        const copyId = () => {
            console.log("pin Data", item)
            navigator.clipboard.writeText(item?._id)
        }

        return (
            <VisDiv style={{border: "1px solid #ccc", borderRadius:"10px", padding: "10px", marginBottom:"10px"}}  key={key} >
                <VisDiv rules={[false]}>
                    <button onClick={pinTestFunction}>testPin</button>
                </VisDiv>
              
                <VisDiv rules={[false]} style={{textAlign:"center", display:"flex"}}>
                    <VisDiv>
                        <button type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={()=>updateLaw()}>
                            <FiSave            
                            size={15}
                            color={"white"}/>
                        </button>
                    </VisDiv>
                    <VisDiv style={{marginLeft:"10px"}}>
                        <button type='button' className='round-back-button' style={{backgroundColor:"blue"}} onClick={()=>copyId()}>
                            <FiCopy            
                            size={15}
                            color={"white"}/>
                        </button>
                    </VisDiv>
                </VisDiv>
               
                <VisDiv style={{display:"flex", padding: "10px"}}>
                    <VisDiv rules={[item?.richText]} style={{flex:1, padding: "10px"}}> 
                        <p>TITOLO LEGGE</p>
                        <TextField onBlur={updateLaw} type="text" onChange={(e)=>addLabel(e)} value={value?.label}/>
                        <RichTextEditor onBlur={updateLaw} noFocus={true}  existingDoc={item?.richText} readOnly={false} editorDoc={editorDocLaw}/>
                    </VisDiv>
                    <VisDiv rules={[item?.details, false]} style={{flex:1, padding: "10px"}}>
                        <RichTextEditor onBlur={updateLaw} noFocus={true} existingDoc={item?.details} readOnly={false} editorDoc={editorDocDetails}/> 
                    </VisDiv>
                </VisDiv>
                <VisDiv>
                        <h3>PRODOTTI A CUI E' ASSEGNATA LA LEGGE</h3>
                        <p style={{marginBottom:"14px", color:"grey"}}>Cliccare sul prodotto qui sotto per assegnargli una legge diversa</p>
                        {lawProductsLabels}
                    </VisDiv>
            </VisDiv>
        )
    }

    export const LawProductsLabels = ({index, product, laws}) => {
        
        const [productDoc, setProductDoc] = useState(product)

        const lawDoc = (lawId) => ({_ref: lawId, _key: keyId(), _type:"reference"})
        const queryClient = useQueryClient()
        const [law, setLaw] = useState(!Array.isArray(laws) ? undefined : laws?.find?.((x)=>product?.law?._ref == x?._id))
        const [edit, setEdit] = useState(false)

        const {mutate: updateDocument} = useCreateReplace({
            onMutate: async (newDoc) => {
    
                await queryClient.cancelQueries({ queryKey: ['customerProductsReport'] })
                const previousData = queryClient.getQueryData(['customerProductsReport'])
           
                //const doc = newDoc?.doc
                
                queryClient.setQueryData(['customerProductsReport'], (old) =>{ 
                    const doc = newDoc?.doc
                    const oldData = old?.length > 0 ? old : []
                    const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                    return newData
                })
                return {previousData }
            },
            onError: (err, newDoc, context) => {
                console.error('Oh no, the update failed: ', err?.message)
                errorAlert("Errore: il documento non é stato aggiornato")
            
            }
            })
        const updateLaw = (doc) => {
            const queryDoc = {
                doc: doc,
            }
            console.log("SAVE PRODUCT:", queryDoc)
            updateDocument(queryDoc)
        }

        return (
            <div style={{display: "flex", alignItems:"center", padding:"3px"}}>
                <p onClick={()=>setEdit(!edit)} style={{marginRight:"10px"}} key={product?._id}>{product?.label}</p>
                <VisDiv style={{display: "flex", alignItems:"center"}} rules={[edit]}>
                <FieldDropdown
                        isSearchable="isSearchable"
                        initialValue={{...law, value: product?.label}}
                        placeHolder={"LEGGE"}
                        options={addValueForDropdown(laws)?.sort(sortByLabel)}
                        onChange={(value) => {
                            setLaw(value)
                            const newValue = {
                                ...product, 
                                law: lawDoc(value?._id), 
                              }
                              setProductDoc(newValue)
                              updateLaw(newValue)
                        }
                        }
                    />
                <div style={{textAlign:"center", marginLeft:"10px"}}>
                    <VisDiv rules={[false]}>
                        <button type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={()=>updateLaw(productDoc)}>
                            <FiSave            
                            size={15}
                            color={"white"}/>
                        </button>
                    </VisDiv>
                </div>
                </VisDiv>
            </div>
        
        )
    }